import BigNumber from 'bignumber.js';
import { DlVault } from 'types/contracts';

export interface GetNetworkRewardsSummaryInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetNetworkRewardsSummaryOutput = {
  totalRewards: BigNumber;
  claimedRewards: BigNumber;
  pendingRewards: BigNumber;
  totalRecords: number;
  activeRewards: number;
  averageRewardPerLevel: BigNumber;
  lastRewardTime: number;
};

const getNetworkRewardsSummary = async ({
  dlVaultContract,
  accountAddress,
}: GetNetworkRewardsSummaryInput): Promise<GetNetworkRewardsSummaryOutput> => {
  const result = await dlVaultContract.methods
    .getNetworkRewardsSummary(accountAddress)
    .call();

  return {
    totalRewards: new BigNumber(result.totalAmount || result[2] || '0'),
    claimedRewards: new BigNumber(result.claimedAmount || result[3] || '0'),
    pendingRewards: new BigNumber(result.availableAmount || result[4] || '0'),
    totalRecords: parseInt(result.totalRecords || result[0] || '0', 10),
    activeRewards: parseInt(result.activeRecords || result[1] || '0', 10),
    averageRewardPerLevel: new BigNumber('0'), // 暂时设为0，等合约更新
    lastRewardTime: 0, // 暂时设为0，等合约更新
  };
};

export default getNetworkRewardsSummary; 